import { SxProps, Theme } from '@mui/material';

import { spacing } from '@/constants/ui';

export const headerTitleStyles: SxProps<Theme> = {
  fontWeight: 700,
  textAlign: {
    xs: 'center',
    md: 'left'
  }
};

export const headerSubtitleStyles: SxProps<Theme> = {
  mb: spacing['3'],
  mt: 1,
  textAlign: {
    xs: 'center',
    md: 'left'
  }
};

export const headerPromptStyles: SxProps<Theme> = {
  mb: spacing['1.5'],
  fontWeight: 700,
  textAlign: {
    xs: 'center',
    md: 'left'
  }
};
